import { render, staticRenderFns } from "./ClinicPageManageTexts.vue?vue&type=template&id=78440a21"
import script from "./ClinicPageManageTexts.vue?vue&type=script&lang=js"
export * from "./ClinicPageManageTexts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports